module.exports = __webpack_public_path__ + "img/Step2-m.22da7f1.svg";